<template>
    <div class="public_container customer_add_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

            </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <CustomFormMobile
                ref="crm_custom_form"
                :field_list="formInfoList"
                :is_form_module="true"
                @submit-form="submitFormData"
                v-if="dataLoaded"
            />
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>

<script>
import { getFormFields, CustomerManageAdd } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "MCustomerManageTpl",
    components: { ReturnNavBar, CustomFormMobile },
    data() {
        return {
            customer_id: this.$route.query && this.$route.query.customer_id,
            loading: false,
            formInfoList: [],
            dataLoaded: false,
            btnDisabled: false,
        };
    },
    created() {
        this._getFromFields();
    },
    methods: {
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "customer_manages",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    this.loading = false;
                    this.dataLoaded = true;
                }
            });
        },
        handleClickConfirm() {
            this.$refs.crm_custom_form.handleClickPublish();
        },
        submitFormData(customForm) {
            if (customForm) {
                const form = {
                    customer_id: this.customer_id,
                    ...customForm,
                };
                CustomerManageAdd(form)
                    .then((res) => {
                        this.loading = false;
                        this.btnDisabled = false;
                        if (res.code == 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.go(-1);
                                },
                            });
                        } else {
                            this.$toast({
                                message: res.message,
                                type: "fail",
                            });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.btnDisabled = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.customer_add_wrap {
    .mobile_container {
        padding: 10px 0;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
